import PayModalTemplate from './PayModalTemplate';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as uiActions from "Actions/uiActions";
var _ = require('lodash');

function mapStateToProps(state) {
	return {
		showModal: state.ui.showPayModal,
		disablePayModal: state.ui.disablePayModal,
		account: !_.isEmpty(state.accounts.accounts) ? state.accounts.accounts[state.accounts.currentAccount] : {}
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(uiActions, dispatch),
        uiActions: bindActionCreators(uiActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(PayModalTemplate);



// WEBPACK FOOTER //
// ./src/components/atomic/templates/PayModalTemplate/index.js